import { useEffect, useState } from 'react';
import { ScrollSource, scrollEvents } from './internal/scroll-event-bus';

/**
 * Detect Scroll Source
 * 
 * WHY: Tabs need to know their context to publish events to the correct subscriber.
 * 
 * PROBLEM: The same tab component renders in both:
 * - Regular address pages (scroll target: window)
 * - Address modals (scroll target: modal container)
 * 
 * SOLUTION: Infer context from registered scroll detection subscribers.
 * - Whoever calls useScrollDetection('modal') declares modal context
 * - Whoever calls useScrollDetection('window') declares window context
 * - No prop drilling required
 * - No domain-specific context dependencies
 * - Fully reusable across any page/modal scenario
 * 
 * This hook provides the source for event publishing and scoped element search.
 */
export function useScrollSource(): ScrollSource {
  const [source, setSource] = useState<ScrollSource>(() => scrollEvents.getActiveSource());

  useEffect(() => {
    // Re-check on mount in case subscribers changed
    setSource(scrollEvents.getActiveSource());
  }, []);

  return source;
}
